import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import constants from '@core/config/constants'
import storageService from '@core/persistence/localStorage/localStorageService'

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(storageService.getItem(constants.LOCAL_STORAGE_KEYS.TOKEN))
  const refreshToken = ref<string | null>(
    storageService.getItem(constants.LOCAL_STORAGE_KEYS.REFRESH_TOKEN),
  )
  const verificationId = ref<string | null>(null)
  const permissions = ref<string[]>([])

  const isAuthenticated = computed(() => Boolean(token.value))

  function setToken(value: string) {
    token.value = value
    storageService.setItem(constants.LOCAL_STORAGE_KEYS.TOKEN, value)
  }

  function setRefreshToken(value: string) {
    refreshToken.value = value
    storageService.setItem(constants.LOCAL_STORAGE_KEYS.REFRESH_TOKEN, value)
  }

  function setVerificationId(value: string | null) {
    verificationId.value = value
  }

  function logout() {
    token.value = null
    refreshToken.value = null
    verificationId.value = null
    storageService.removeItem(constants.LOCAL_STORAGE_KEYS.TOKEN)
    storageService.removeItem(constants.LOCAL_STORAGE_KEYS.REFRESH_TOKEN)
  }

  return {
    token,
    refreshToken,
    verificationId,
    permissions,
    isAuthenticated,
    setToken,
    setRefreshToken,
    setVerificationId,
    logout,
  }
})
